import { render } from "./BookingModifyReview.vue?vue&type=template&id=13503894"
import script from "./BookingModifyReview.vue?vue&type=script&lang=js"
export * from "./BookingModifyReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/BookingModifyReview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13503894"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13503894', __exports__)) {
    api.reload('13503894', __exports__)
  }
  
  module.hot.accept("./BookingModifyReview.vue?vue&type=template&id=13503894", () => {
    api.rerender('13503894', render)
  })

}


export default __exports__